import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import QuickBudgetButton from 'src/components/plaid/budget/QuickBudgetButton';
import OnboardingModal, { useRequiresOnboarding } from 'src/components/onboarding/OnboardingDialog';
import Confetti from 'src/components/confetti';
import useDebounce from 'src/hooks/use-debounce';
import { useFinanceContext } from 'src/components/plaid/datasource';
import Main from './main';
import Header from './header';

// ----------------------------------------------------------------------

const Accessories = () => {
  const { setRollup } = useFinanceContext();
  const requiresOnboarding = useRequiresOnboarding();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [celebrate, setCelebrate] = useState(false);

  // Only set the state when onboarding is required.
  // A manual dismiss is still required to dismiss it.
  useEffect(() => {
    if (requiresOnboarding && !showOnboarding) setShowOnboarding(requiresOnboarding);
  }, [requiresOnboarding]);

  // automatically turn off the confetti to prevent re-fires on state change
  const celebrateComplete = useDebounce(celebrate, 3000);
  useEffect(() => {
    if (celebrate) setCelebrate(false);
  }, [celebrateComplete]);

  // show confetti when completing onboarding
  const handleOnboardingComplete = (options) => {
    setShowOnboarding(false);
    if (options?.complete) setCelebrate(true);
    setRollup('month');
  };

  return (
    <>
      <Confetti trigger={celebrate} />
      <OnboardingModal open={!!showOnboarding} onClose={handleOnboardingComplete} />
      <QuickBudgetButton />
    </>
  );
};

export default function DashboardLayout({ children }) {
  return (
    <>
      <Accessories />
      <Header />
      <Main>{children}</Main>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
